<template>
  <div class="card p-shadow-app" :style="{ position: 'relative' }">
    <h2>Suporte</h2>
    <Loading :active.sync="loading" :isFullPage="false"></Loading>
    <PatMarkIntervention
      :show="markIntervention.show"
      :pat="markIntervention.pat"
      @close="closedIntervention"
      @marked="markedIntervention"
    />
    <div class="p-fluid p-grid">
      <div class="field p-col-12 p-md-3 p-mt-2">
        <span class="p-float-label">
          <MultiSelect
            name="moreTechnicals"
            :options="patsStatus"
            :filter="true"
            :optionLabel="'field'"
            :optionValue="'id'"
            :dataKey="'id'"
            v-model="patsStatusSelected"
            display="chip"
          >
            <template #option="slotProps">
              <div class="item">
                <div>{{ slotProps.option.field }}</div>
                <div
                  class="item-color"
                  :style="{
                    backgroundColor: slotProps.option.color,
                  }"
                ></div>
              </div>
            </template>
            <template #value="slotProps">
              <div class="p-d-flex p-flex-wrap">
                <div
                  class="my-chip p-mr-2 p-mb-1"
                  v-for="status of slotProps.value"
                  :key="status"
                >
                  <div
                    class="item-color"
                    :style="{
                      backgroundColor: getStatusById(status).color,
                    }"
                  ></div>
                  <span class="chip-label">{{
                    getStatusById(status).field
                  }}</span>
                  <i
                    class="pi pi-times chip-remove-icon"
                    @click="removeStatus(status)"
                  ></i>
                </div>
              </div>
            </template>
          </MultiSelect>
          <label for="inputtext">Estados</label>
        </span>
      </div>
      <div class="field p-col-12 p-md-2 p-mt-2">
        <span class="p-float-label">
          <Dropdown
            id="brand"
            name="brand"
            v-model="brandSelected"
            :options="brands"
            :filter="true"
            :showClear="true"
          />
          <label for="brand">Marca do Equipamento</label>
        </span>
      </div>
      <div class="field p-col-12 p-md-3 p-mt-2">
        <span class="p-float-label">
          <MultiSelect
            name="technicians"
            :options="technicians"
            :filter="true"
            :optionLabel="'username'"
            :optionValue="'tecnico'"
            :dataKey="'tecnico'"
            v-model="techniciansSelected"
            display="chip"
          >
            <template #option="slotProps">
              <div class="item">
                <div>{{ slotProps.option.username }}</div>
                <div
                  class="item-color"
                  :style="{
                    backgroundColor: slotProps.option.tecnhician_color,
                  }"
                ></div>
              </div>
            </template>
            <template #value="slotProps">
              <div class="p-d-flex p-flex-wrap">
                <div
                  class="my-chip p-mr-2 p-mb-1"
                  v-for="technicianId of slotProps.value"
                  :key="technicianId"
                >
                  <div
                    class="item-color"
                    :style="{
                      backgroundColor:
                        getTechnicianById(technicianId).tecnhician_color,
                    }"
                  ></div>
                  <span class="chip-label">{{
                    getTechnicianById(technicianId).username
                  }}</span>
                  <i
                    class="pi pi-times chip-remove-icon"
                    @click="removeTechnician(technicianId)"
                  ></i>
                </div>
              </div>
            </template>
          </MultiSelect>
          <label for="technicians">Intervenções dos Técnicos</label>
        </span>
      </div>
      <div class="p-col-12 p-md-2 p-mt-2">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="pi pi-calendar"></i>
          </span>
          <span class="p-float-label">
            <v-date-picker
              v-model="dayStart"
              :masks="{
                input: 'DD-MM-YYYY',
              }"
              @dayclick="dayStartChanged"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <span class="p-float-label">
                  <input
                    id="dayStart"
                    name="dayStart"
                    v-bind:class="[
                      'form-control',
                      'p-inputtext',
                      'p-component',
                      'p-filled',
                    ]"
                    :value="inputValue"
                    v-on="inputEvents"
                  />
                  <label for="dayStart">Dia Inicio</label>
                </span>
              </template>
            </v-date-picker>
          </span>
        </div>
      </div>
      <div class="p-col-12 p-md-2 p-mt-2">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="pi pi-calendar"></i>
          </span>
          <span class="p-float-label">
            <v-date-picker
              v-model="dayEnd"
              :masks="{
                input: 'DD-MM-YYYY',
              }"
              @dayclick="dayEndChanged"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <span class="p-float-label">
                  <input
                    name="dayEnd"
                    id="dayEnd"
                    v-bind:class="[
                      'form-control',
                      'p-inputtext',
                      'p-component',
                      'p-filled',
                    ]"
                    :value="inputValue"
                    v-on="inputEvents"
                  />
                  <label for="dayEnd">Dia Fim</label>
                </span>
              </template>
            </v-date-picker>
          </span>
        </div>
      </div>

      <div class="p-col-12 p-md-1 p-mt-2">
        <Button
          label="Ver"
          icon="pi pi-eye"
          class="p-button-success"
          @click="saveMapFilters(); initMapTasks()"
        />
      </div>
      <!-- v-if="patsStatusList.length && !showButtonView" -->
      <div v-if="false" class="p-col-12 p-md-3 p-mt-2">
        <Button
          :label="'Sugerir rotas (' + patsStatusList.length + ' intervenções)'"
          icon="pi pi-star"
          class="p-button-secondary"
          @click.prevent="initMapRoutesSuggestions"
        />
      </div>
      <div v-if="Object.keys(suggestionsRoutes).length && !showButtonView" class="p-col-12 p-md-3 p-mt-2">
        <Button
          label="Ver rotas otimizadas"
          icon="pi pi-eye"
          class="p-button-success"
          @click.prevent="showSidebar = true"
        />
      </div>
    </div>
    <div class="p-col-12 p-md-112">
      <div style="height: 900px; width: 100%">
        <l-map
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          style="height: 100%"
          ref="myMap"
          :key="mapID"
        >
          <l-tile-layer :url="url" :attribution="attribution" />
          <v-geosearch :options="geosearchOptions"></v-geosearch>
          <l-control-fullscreen position="topleft" />

          <l-layer-group v-if="previewRoute">
            <!-- Linha da Rota -->
            <l-polyline
              :lat-lngs="previewRoute.latLngs"
              :color="previewRoute.color"
              :weight="5"
              :opacity="0.8"
            />

            <l-marker
              v-for="(stop, idx) in previewRoute.stops"
              :key="'route_stop_' + idx"
              :lat-lng="stop.latLng"
              :icon="createRouteIcon(stop.number, previewRoute.color)"
              :z-index-offset="1000"
            >
              <l-popup>
                <div>
                  <b>Ordem #{{ stop.number }}</b><br/>
                  <b>Técnico:</b> {{ getTechName(previewRoute.techId) }}<br/>
                  <b>Chegada:</b> {{ stop.arrival }}<br/>
                  <b>Partida:</b> {{ stop.departure }}<br />
                  <hr style="margin: 5px 0"/>
                </div>
                <div><b>Pat: </b> {{ stop.pat.pat_id }}</div>
                <div><b>Estado: </b> {{ stop.pat.pat_status }}</div>
                <div><b>Marca Equipamento: </b> {{ stop.pat.equipment_brand }}</div>
                <div><b>Modelo Equipamento: </b> {{ stop.pat.equipment_model }}</div>
                <div><b>Cliente: </b> {{ stop.pat.client.name }}</div>
                <div v-if="stop.pat.entity">
                  <b>Entidade: </b> {{ stop.pat.entity.name }}
                </div>
                <div>
                  <b>Morada: </b>
                  {{ stop.pat.entity ? stop.pat.entity.address : stop.pat.client.address }}
                </div>
                <div>
                  <b>Cód. Postal: </b>
                  {{ stop.pat.entity ? stop.pat.entity.zipCode : stop.pat.client.zipCode }}
                </div>
                <div>
                  <b>Cidade: </b>
                  {{ stop.pat.entity ? stop.pat.entity.city : stop.pat.client.city }}
                </div>
                <div>
                  <b>Telefone: </b>
                  {{ stop.pat.entity ? stop.pat.entity.telephone : stop.pat.client.telephone }}
                </div>
                <div v-if="!stop.pat.entity">
                  <b>Telemóvel: </b> {{ stop.pat.client.mobilPhone }}
                </div>
                <div v-if="stop.pat.solucao">
                  <b>Solução: </b> {{ stop.pat.solucao }}
                </div>
                <div class="p-mt-2">
                  <Button
                    label="Ver Pat"
                    icon="pi pi-eye"
                    class="p-button-sm p-button-success p-mr-1"
                    @click="goToPat(stop.pat.pat_id)"
                  />
                  <Button
                    label="Marcar Intervenção"
                    icon="pi pi-eye"
                    class="p-button-sm p-button-primary"
                    @click="addIntervention(stop.pat)"
                  />
                </div>
              </l-popup>
            </l-marker>
          </l-layer-group>

          <v-marker-cluster
            ref="clusterRefTask"
            :options="taskClusterOptions"
            class="cluster-tasks"
          >
            <l-marker
              v-for="(task, index) in tasks"
              :key="index"
              ref="markersTasks"
              :lat-lng="task.latLng"
              :options="{ index: index }"
              :icon="createSVGMarker(task.tecnician_color)"
            >
              <l-popup>
                <div><b>Pat: </b> {{ task.pat_id }}</div>
                <div><b>Estado do Pat: </b> {{ task.pat_status }}</div>
                <div><b>Ténico: </b> {{ task.tecnician_name }}</div>
                <div><b>Dia/Hora: </b> {{ task.date }} {{ task.hour }}</div>
                <div><b>Cliente: </b> {{ task.client.name }}</div>
                <div v-if="task.entity">
                  <b>Entidade: </b> {{ task.entity.name }}
                </div>
                <div>
                  <b>Morada: </b>
                  {{ task.entity ? task.entity.address : task.client.address }}
                </div>
                <div>
                  <b>Cód. Postal: </b>
                  {{ task.entity ? task.entity.zipCode : task.client.zipCode }}
                </div>
                <div>
                  <b>Cidade: </b>
                  {{ task.entity ? task.entity.city : task.client.city }}
                </div>
                <div>
                  <b>Telefone: </b>
                  {{
                    task.entity ? task.entity.telephone : task.client.telephone
                  }}
                </div>
                <div v-if="!task.entity">
                  <b>Telemóvel: </b> {{ task.client.mobilPhone }}
                </div>
                <div v-if="task.solucao">
                  <b>Solução: </b> {{ task.solucao }}
                </div>
                <div class="p-mt-2">
                  <Button
                    label="Ver Pat"
                    icon="pi pi-eye"
                    class="p-button-sm p-button-success"
                    @click="goToPat(task.pat_id)"
                  />
                </div>
              </l-popup>
            </l-marker>
          </v-marker-cluster>
          <v-marker-cluster
            ref="clusterRefPats"
            :options="patClusterOptions"
            class="cluster-pats"
          >
            <l-marker
              v-for="(pat, index) in patsStatusList"
              :key="'pat_' + pat.pat_id"
              ref="markersTasksPat"
              :lat-lng="pat.latLng"
              :options="{ index: index }"
              :icon="createSVGMarkerStatus(pat.pat_status, pat.open_days)"
            >
              <l-popup>
                <div><b>Pat: </b> {{ pat.pat_id }}</div>
                <div><b>Estado: </b> {{ pat.pat_status }}</div>
                <div><b>Técnico: </b> {{ pat.technician_name }}</div>
                <div>
                  <b>Técnico Data: </b> {{ pat.technician_date }}
                  {{ pat.technician_time }}
                </div>
                <div><b>Marca Equipamento: </b> {{ pat.equipment_brand }}</div>
                <div><b>Modelo Equipamento: </b> {{ pat.equipment_model }}</div>
                <div><b>Cliente: </b> {{ pat.client.name }}</div>
                <div v-if="pat.entity">
                  <b>Entidade: </b> {{ pat.entity.name }}
                </div>
                <div>
                  <b>Morada: </b>
                  {{ pat.entity ? pat.entity.address : pat.client.address }}
                </div>
                <div>
                  <b>Cód. Postal: </b>
                  {{ pat.entity ? pat.entity.zipCode : pat.client.zipCode }}
                </div>
                <div>
                  <b>Cidade: </b>
                  {{ pat.entity ? pat.entity.city : pat.client.city }}
                </div>
                <div>
                  <b>Telefone: </b>
                  {{ pat.entity ? pat.entity.telephone : pat.client.telephone }}
                </div>
                <div v-if="!pat.entity">
                  <b>Telemóvel: </b> {{ pat.client.mobilPhone }}
                </div>
                <div v-if="pat.solucao">
                  <b>Solução: </b> {{ pat.solucao }}
                </div>
                <div class="p-mt-2">
                  <Button
                    label="Ver Pat"
                    icon="pi pi-eye"
                    class="p-button-sm p-button-success p-mr-1"
                    @click="goToPat(pat.pat_id)"
                  />
                  <Button
                    label="Marcar Intervenção"
                    icon="pi pi-eye"
                    class="p-button-sm p-button-primary"
                    @click="addIntervention(pat)"
                  />
                </div>
              </l-popup>
            </l-marker>
          </v-marker-cluster>
        </l-map>
      </div>
      <div>
        <small class="p-mt-2">
          <b>Legenda:</b>
        </small>
        <div class="p-d-flex p-flex-wrap p-mt-2">
          <div class="p-ml-3 p-d-flex p-ai-center">
            <div class="custom-cluster-tasks legend-cluster">
              <div class="cluster-tasks-icon">5</div>
            </div>
            <small class="p-ml-2">Aglomerado intervenções</small>
          </div>
          <div class="p-ml-3 p-d-flex p-ai-center">
            <div v-html="createSVGMarker().options.html"></div>
            <small class="p-ml-2">Marcador Intervenções</small>
          </div>
          <div class="p-ml-3 p-d-flex p-ai-center">
            <div class="custom-cluster-pats legend-cluster">
              <div class="cluster-pats-icon">5</div>
            </div>
            <small class="p-ml-2">Aglomerado PATs</small>
          </div>
          <div class="p-ml-3 p-d-flex p-ai-center">
            <div v-html="createSVGMarkerStatus().options.html"></div>
            <small class="p-ml-2">Marcador PATs</small>
          </div>
        </div>
      </div>
    </div>

    <SuggestionRoute
      :showSidebar="showSidebar"
      :suggestions="suggestionsRoutes"
      :interventions="patsStatusList"
      :technicians="technicians"
      @close="showSidebar = false"
      @view-route="handleViewRoute"
    ></SuggestionRoute>
  </div>
</template>

<script>
import chroma from "chroma-js";
import PatService from "@/services/pat.service";
import TaskService from "@/services/task.service";
import vrpService from "../services/vrp.service.js";
import equipmentService from "@/services/equipment.service";
import PatMarkIntervention from "@/components/support/PatMarkIntervention.vue";
import { getOnlyDate } from "@/helpers/helpers";
import "vue-loading-overlay/dist/vue-loading.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet-geosearch/assets/css/leaflet.css";
import Loading from "vue-loading-overlay";
import { latLng, divIcon } from "leaflet";
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LPolyline, LLayerGroup } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import Vue2LeafletFullScreen from "vue2-leaflet-fullscreen";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";
import SuggestionRoute from "../components/support/SuggestionRoute.vue";
export default {
  name: "SupportMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolyline,
    LLayerGroup,
    Loading,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    "v-geosearch": VGeosearch,
    "l-control-fullscreen": Vue2LeafletFullScreen,
    PatMarkIntervention,
    SuggestionRoute,
  },
  data() {
    return {
      loading: false,
      map: null,
      showSidebar: false,
      suggestionsRoutes: {},
      previewRoute: null,
      routeSuggestionsVersion: 0,
      geosearchOptions: {
        provider: new OpenStreetMapProvider(),
        // style: "bar",
        showMarker: true,
        showPopup: false,
        autoClose: true,
        retainZoomLevel: false,
        animateZoom: true,
        keepResult: false,
        searchLabel: "Pesquisar localidade",
      },
      zoom: 7,
      center: latLng(39.2895048, -8.6267249),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentCenter: null,
      mapOptions: {
        zoomSnap: 0.5,
      },
      staticAnchor: [16, 37],
      mapID: Math.random(),
      dayStart: new Date(),
      dayEnd: new Date(),
      showButtonView: false,
      patsStatus: [],
      patsStatusSelected: [],
      technicians: [],
      techniciansSelected: [],
      brands: [],
      brandSelected: null,
      tasks: [],
      patsStatusList: [],
      taskClusterOptions: {
        chunkedLoading: true,
        maxClusterRadius: 1,
        disableClusteringAtZoom: 18,
        iconCreateFunction: function (cluster) {
          return L.divIcon({
            html:
              '<div class="cluster-tasks-icon">' +
              cluster.getChildCount() +
              "</div>",
            className: "custom-cluster-tasks",
            iconSize: [40, 40],
          });
        },
      },
      patClusterOptions: {
        chunkedLoading: true,
        maxClusterRadius: 1,
        disableClusteringAtZoom: 18,
        iconCreateFunction: function (cluster) {
          return L.divIcon({
            html:
              '<div class="cluster-pats-icon">' +
              cluster.getChildCount() +
              "</div>",
            className: "custom-cluster-pats",
            iconSize: [40, 40],
          });
        },
      },
      markIntervention: { show: false, pat: {} },
    };
  },
  computed: {
    filtersStorageKey() {
      const user = this.$store.state.auth.user;
      return user && user.id != null ? `supportMapFilters:${user.id}` : null;
    },
    mapFilters() {
      return [
        this.patsStatusSelected,
        this.techniciansSelected,
        this.brandSelected,
        this.dayStart,
        this.dayEnd,
      ];
    },
  },
  watch: {
    mapFilters: {
      deep: true,
      handler() {
        this.showButtonView = true;
        this.clearRouteSuggestions();
      },
    },
  },
  async created() {
    this.loading = true;
    if (this.$route.params.date) {
      const parts = this.$route.params.date.split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const day = parseInt(parts[2], 10);
        const parsedDate = new Date(year, month, day);
        if (!isNaN(parsedDate.getTime())) {
          this.dayStart = parsedDate;
          this.dayEnd = parsedDate;
        }
      }
    }
    const [statusRes, techRes, brandRes] = await Promise.all([
      PatService.statusToMap(),
      PatService.getTechnicians(),
      equipmentService.getAllEquipmentsBrands()
    ]);
    this.patsStatus = statusRes;
    this.technicians = techRes;
    this.brands = [...(brandRes || [])];
    this.restoreMapFilters();
    return (this.loading = false);
  },
  methods: {
    saveMapFilters() {
      if (!this.filtersStorageKey) return;
      try {
        localStorage.setItem(this.filtersStorageKey, JSON.stringify({
          patsStatusSelected: this.patsStatusSelected,
          brandSelected: this.brandSelected,
          techniciansSelected: this.techniciansSelected,
        }));
      } catch (error) {
        console.error("Could not save support map filters", error);
      }
    },
    restoreMapFilters() {
      if (!this.filtersStorageKey) return;
      try {
        const saved = JSON.parse(localStorage.getItem(this.filtersStorageKey));
        if (!saved || typeof saved !== "object" || Array.isArray(saved)) return;
        this.patsStatusSelected = Array.isArray(saved.patsStatusSelected)
          ? saved.patsStatusSelected.filter(id => this.getStatusById(id)) : [];
        this.techniciansSelected = Array.isArray(saved.techniciansSelected)
          ? saved.techniciansSelected.filter(id => this.getTechnicianById(id)) : [];
        this.brandSelected = this.brands.includes(saved.brandSelected) ? saved.brandSelected : null;
        this.showButtonView = true;
      } catch (error) {
        console.error("Could not restore support map filters", error);
      }
    },
    clearRouteSuggestions() {
      this.routeSuggestionsVersion++;
      this.suggestionsRoutes = {};
      this.previewRoute = null;
      this.showSidebar = false;
    },
    getTechnicianById(id) {
      return this.technicians.find((tech) => tech.tecnico === id);
    },
    getStatusById(id) {
      return this.patsStatus.find((status) => status.id === id);
    },
    getStatusByName(name) {
      return this.patsStatus.find((status) => status.field === name);
    },
    dayStartChanged(date) {
      this.dayStart = date.id;
    },
    dayEndChanged(date) {
      this.dayEnd = date.id;
    },
    goToPat(patId) {
      this.$router.push(`/pats/${patId}`);
    },
    async initMapTasks() {
      this.clearRouteSuggestions();
      this.loading = true;
      if (this.techniciansSelected.length > 0) {
        let startDate =
          this.dayStart instanceof Date
            ? this.dayStart
            : new Date(this.dayStart);
        let endDate =
          this.dayEnd instanceof Date ? this.dayEnd : new Date(this.dayEnd);

        await TaskService.tasksBetweenDates(
          getOnlyDate(startDate),
          getOnlyDate(endDate),
          this.techniciansSelected
        ).then((response) => {
          this.tasks = response.map((task) => ({
            ...task,
            latLng: latLng(task.latitude, task.longitude),
          }));
        });
      } else {
        this.tasks = [];
      }
      if (this.patsStatusSelected.length > 0) {
        await PatService.getMultipleStatus(this.patsStatusSelected, this.brandSelected).then(
          (response) => {
            this.patsStatusList = response.map((pat) => ({
              ...pat,
              latLng: latLng(pat.latitude, pat.longitude),
            }));
          }
        );
      } else {
        this.patsStatusList = [];
      }
      this.showButtonView = false;
      return (this.loading = false);
    },
    createSVGMarker(color = "#3388ff") {
      const svgIcon = `
      <svg width="25" height="41" viewBox="0 0 25 41" xmlns="http://www.w3.org/2000/svg">
        <path fill="${color}" stroke="#fff" stroke-width="1" d="M12.5,0C5.6,0,0,5.6,0,12.5c0,7.8,12.5,28.5,12.5,28.5s12.5-20.7,12.5-28.5C25,5.6,19.4,0,12.5,0z"/>
        <circle fill="#fff" cx="12.5" cy="12.5" r="4"/>
      </svg>
    `;

      return divIcon({
        html: svgIcon,
        className: "custom-svg-marker",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
      });
    },
    createSVGMarkerStatus(statusName, count = 0) {
      let color = "#3388ff";
      let status = this.getStatusByName(statusName);
      if (status) {
        color = status.color;
      }

      const countStr = count.toString();
      const digitCount = countStr.length;

      let badgeWidth = Math.max(20, digitCount * 8 + 8);
      let fontSize = digitCount > 2 ? 10 : 12;
      let badgeX = 30 + (badgeWidth - 20) / 2;
      let textColor = this.getReadableTextColor(color);
      const svgIcon = `
        <svg width="${45 + (badgeWidth - 20)}" height="35" viewBox="0 0 ${
        45 + (badgeWidth - 20)
      } 35" xmlns="http://www.w3.org/2000/svg">
          <!-- Ícone principal -->
          <circle cx="15" cy="15" r="13" fill="${color}" stroke="${textColor}" stroke-width="2"/>
          <g transform="translate(15,15)">
            <!-- Seu ícone aqui -->
            <rect x="-6" y="-5" width="12" height="8" fill="${textColor}" stroke="${textColor}" stroke-width="0.5" rx="1"/>
            <rect x="-5" y="-4" width="10" height="6" fill="${color}" rx="0.5"/>
          </g>
          <!-- Badge responsivo -->
          ${
            count > 1
              ? `
            <ellipse cx="${badgeX}" cy="8" rx="${
                  badgeWidth / 2
                }" ry="10" fill="${color}" stroke="${textColor}" stroke-width="2"/>
            <text x="${badgeX}" y="13" text-anchor="middle" fill="${textColor}" font-size="${fontSize}" font-weight="bold">${count}</text>
          `
              : ""
          }
        </svg>
      `;

      return divIcon({
        html: svgIcon,
        className: "custom-svg-marker",
        iconSize: [30, 30],
        iconAnchor: [15, 15],
        popupAnchor: [0, -15],
      });
    },
    getReadableTextColor(backgroundColor) {
      const whiteContrast = chroma.contrast(backgroundColor, "#ffffff");
      const blackContrast = chroma.contrast(backgroundColor, "#000000");
      return whiteContrast > blackContrast ? "#ffffff" : "#000000";
    },
    clearTasksCluster() {
      if (this.$refs.clusterRefTask) {
        this.$refs.clusterRefTask.mapObject.clearLayers();
      }
    },
    clearPatsCluster() {
      if (this.$refs.clusterRefPats) {
        this.$refs.clusterRefPats.mapObject.clearLayers();
      }
    },
    removeTechnician(technicianId) {
      this.techniciansSelected = this.techniciansSelected.filter(
        (id) => id !== technicianId
      );
    },
    removeStatus(statusId) {
      this.patsStatusSelected = this.patsStatusSelected.filter(
        (id) => id !== statusId
      );
    },
    addIntervention(pat) {
      return (this.markIntervention = {
        show: true,
        pat: pat,
      });
    },
    closedIntervention() {
      return (this.markIntervention = {
        show: false,
        pat: {},
      });
    },
    async markedIntervention() {
      await this.initMapTasks();
      return this.closedIntervention();
    },
    async initMapRoutesSuggestions() {
      if (this.loading || this.showButtonView || !this.patsStatusList.length) return;
      this.clearRouteSuggestions();
      const version = this.routeSuggestionsVersion;
      this.loading = true;

      if (!this.techniciansSelected.length && !this.technicians.length) {
        this.loading = false;
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Nenhum técnico selecionado para sugerir rotas.",
          life: 5000,
        });
        return;
      }

      let techniciansIds = this.techniciansSelected.length
        ? this.techniciansSelected
        : this.technicians.map((tech) => tech.tecnico);

      let technicians = techniciansIds.map(techId => ({
        id: techId,
        depot: { latitude: 38.7761, longitude: -9.3339  }
      }));

      let tasks = this.patsStatusList.map(pat => ({
        id: pat.pat_id,
        latitude: pat.latitude,
        longitude: pat.longitude,
        service_time: pat.pat_status === 'PRONTO**PARA ENTREGA' ? 120 : 2700,
      }));

      let data = {
        tasks,
        technicians,
      };

      try {
        const response = await vrpService.routesSuggestions(data);
        if (version !== this.routeSuggestionsVersion) return;
        if (
          !response || !response.summary || !response.schedules ||
          typeof response.schedules !== "object" || Array.isArray(response.schedules) ||
          Object.values(response.schedules).some(schedule => !schedule || !Array.isArray(schedule.route))
        ) {
          throw new Error("Invalid route suggestions response");
        }
        this.suggestionsRoutes = response;
        this.showSidebar = true;
      } catch (error) {
        if (version !== this.routeSuggestionsVersion) return;
        console.error('Error fetching route suggestions:', error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao sugerir rotas",
          detail: "Não foi possível obter sugestões de rotas. Tente novamente.",
          life: 5000,
        });
      } finally {
        this.loading = false;
      }
    },
    handleViewRoute({ techId, route }) {
      if (this.previewRoute && this.previewRoute.techId === techId) {
        this.previewRoute = null;
        return;
      }

      const tech = this.technicians.find(t => t.tecnico === parseInt(techId));
      const color = tech ? tech.tecnhician_color : '#3388ff';

      const latLngs = route.map(stop => [stop.lat, stop.lon]);

      this.previewRoute = {
        techId,
        color,
        latLngs,
        stops: route.map((stop, i) => ({
          ...stop,
          latLng: [stop.lat, stop.lon],
          number: i + 1,
          pat: this.patsStatusList.find(p => p.pat_id === stop.id),
        }))
      };

      this.$nextTick(() => {
        if (this.$refs.myMap && this.$refs.myMap.mapObject) {
          this.$refs.myMap.mapObject.fitBounds(latLngs, { padding: [50, 50] });
        }
      });
    },

    createRouteIcon(number, color) {
      const textColor = this.getReadableTextColor(color);
      const svgIcon = `
        <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="14" fill="${color}" stroke="white" stroke-width="2"/>
          <text x="15" y="20" text-anchor="middle" fill="${textColor}" font-size="14" font-weight="bold" font-family="Arial">${number}</text>
        </svg>
      `;

      return divIcon({
        html: svgIcon,
        className: "route-stop-marker",
        iconSize: [30, 30],
        iconAnchor: [15, 15],
        popupAnchor: [0, -15],
      });
    },

    getTechName(techId) {
      if (!this.technicians) return '';
      let detail = this.technicians.find(t => t.tecnico == techId);
      if (detail) {
        return detail.username;
      }
      return '';
    }
  },
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: calc(100vh - 250px);
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

/* Aumentar z-index do date picker */
:deep(.vc-container) {
  z-index: 9999 !important;
}

:deep(.vc-popover-content-wrapper) {
  z-index: 9999 !important;
}

:deep(.vc-popover-content) {
  z-index: 9999 !important;
}

/* Garantir que o date picker apareça acima do mapa */
.v-date-picker {
  z-index: 9999 !important;
}

.p-multiselect-panel .p-component {
  z-index: 1001 !important;
}

:deep(.p-multiselect) {
  min-height: 32px !important;
}

:deep(.custom-cluster-tasks) {
  background-color: #097e1d;
  border-radius: 50%;
}

:deep(.cluster-tasks-icon) {
  color: white;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
}

:deep(.custom-cluster-pats) {
  background-color: #1857cc;
  border-radius: 50%;
}

:deep(.cluster-pats-icon) {
  color: white;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
}

.item-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  border: 2px solid #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.my-chip {
  display: inline-flex;
  align-items: center;
  background: #e9ecef;
  border: 1px solid #dee2e6;
  border-radius: 16px;
  padding: 4px 8px;
  font-size: 0.875rem;
  color: #495057;
  margin: 2px;
}

.chip-label {
  margin-right: 6px;
  font-weight: 500;
}

.chip-remove-icon {
  cursor: pointer;
  font-size: 1rem;
  color: #000;
  margin-left: 4px;
}

:deep(.leaflet-top.leaflet-left) {
  z-index: 500 !important; /* Valor mais alto */
}

.legend-cluster {
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  justify-content: center !important;
}

.legend-marker-container svg {
  width: 18px !important;
  height: 18px !important;
  transform: scale(0.7);
  transform-origin: center;
}

.legend-marker-container .custom-svg-marker {
  width: 18px !important;
  height: 18px !important;
}
</style>
